export const SIZE = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tabletS: 576,
    tablet: 768,
    tabletL: 992,
    laptop: 1024,
    laptopM: 1200,
    laptopL: 1440,
    desktopS: 1680,
    desktop: 1980,
}

export const DEVICE = {
    mobileS: `(max-width: ${SIZE.mobileS}px)`,
    mobileM: `(max-width: ${SIZE.mobileM}px)`,
    mobileL: `(max-width: ${SIZE.mobileL}px)`,
    tabletS: `(max-width: ${SIZE.tabletS}px)`,
    tablet: `(max-width: ${SIZE.tablet}px)`,
    tabletL: `(max-width: ${SIZE.tabletL}px)`,
    laptopS: `(min-width: ${SIZE.tabletL}px)`,
    laptop: `(max-width: ${SIZE.laptop}px)`,
    laptopM: `(max-width: ${SIZE.laptopM}px)`,
    laptopL: `(max-width: ${SIZE.laptopL}px)`,
    desktopS: `(min-width: ${SIZE.desktopS}px)`,
    desktop: `(max-width: ${SIZE.desktop}px)`,
    desktopL: `(min-width: ${SIZE.desktop}px)`,
}
